export interface UserInfo {
  tenantId: string;
  firstName: string;
  lastName: string;
  icAgentId: string;
  userName: string;
  icBUId: number;
  icClusterId: string;
  userId: string;
  teamId: number;
  tenant: string;
  digitalUserId: number;
  digitalBrandId: number;
}

export function getUserIfoInLocalStorage(): UserInfo | null {
  const userKeyInLocalStroage = 'user_info';
  const userInfoInLocalStorage = window.localStorage.getItem(
    userKeyInLocalStroage,
  );

  if (userInfoInLocalStorage === null) return null;

  const userInfo: UserInfo = JSON.parse(userInfoInLocalStorage);

  return userInfo;
}
